import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasPool = createSelector(selectJsonQuery, jsonQuery => getTermValue('pool')(jsonQuery));
